import { Tooltip, Button } from "@mui/material";
import { Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import DoneAllIcon from "@mui/icons-material/DoneAll";

function PayerManagementForm() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  const initialValues = {
    payerName: "",
    tpaName: "",
    payerVarNo: "",
    payerCrNo: "",
    effectiveDate: "",
    endDate: "",
    telephone: "",
    accountManager: "",
    accountManagerMobile: "",
    providerNo: "",
    payerChi: "",
    street: "",
    additionalStreet: "",
    buildingNumber: "",
    city: "",
    postalCode: "",
    provinceState: "",
    districtNeighborhood: "",
    generalPercent: "",
    labPercent: "",
    radiologyPercent: "",
    oralPercent: "",
    medsPercent: "",
    procedurePercent: "",
    packagePercent: "",
    promptPayment: "",
    approvalLimit: "",
    notCoveredIcd: "",
    approvalIcd: "",
    supplyDaysApprovals: "",
  };

  const validationSchema = Yup.object().shape({
    payerName: Yup.string().required("Required"),
    tpaName: Yup.string().required("Required"),
    telephone: Yup.string().required("Required"),
    accountManager: Yup.string().required("Required"),
    accountManagerMobile: Yup.string().required("Required"),
    street: Yup.string().required("Required"),
    city: Yup.string().required("Required"),
    postalCode: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    console.log("Form submitted:", values);
    // Handle form submission logic here
  };

  return (
    <div className="superGit_container">
      <div className="benefeciary-create">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="patient-details !mb-3">
                <div className="flex  gap-2 !w-full items-center">
                  <div className="back" onClick={handleGoBack}>
                    {i18n.language == "en" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                          fill="#4D4D53"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g transform="scale(-1,1) translate(-24,0)">
                          <path
                            d="M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z"
                            fill="#4D4D53"
                          />
                        </g>
                      </svg>
                    )}
                  </div>
                  <div className="">
                    <Tooltip placement="right" className="my-auto !mt-2">
                      <span className="font-semibold text-black/70 text-lg ">
                        {t("New Payer Form")}
                        <br />
                      </span>
                    </Tooltip>
                  </div>
                </div>
                <div className="details-fields w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3 mt-4">
                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("Payer Name*")}</label>
                    <input
                      placeholder={t("Enter Payer Name")}
                      type="text"
                      name="payerName"
                      value={values.payerName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                    {errors.payerName && touched.payerName && (
                      <p className="max-w-2xl text-sm leading-6 text-red-500">
                        {errors.payerName}
                      </p>
                    )}
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("TPA Name*")}</label>
                    <input
                      placeholder={t("Enter TPA Name")}
                      type="text"
                      name="tpaName"
                      value={values.tpaName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                    {errors.tpaName && touched.tpaName && (
                      <p className="max-w-2xl text-sm leading-6 text-red-500">
                        {errors.tpaName}
                      </p>
                    )}
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("Payer Var No")}</label>
                    <input
                      placeholder={t("Enter Payer Var No")}
                      type="text"
                      name="payerVarNo"
                      value={values.payerVarNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("payer CR No")}</label>
                    <input
                      placeholder={t("Enter payer CR No")}
                      type="text"
                      name="payerCrNo"
                      value={values.payerCrNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("Effective Date")}</label>
                    <input
                      type="date"
                      name="effectiveDate"
                      value={values.effectiveDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("End Date")}</label>
                    <input
                      type="date"
                      name="endDate"
                      value={values.endDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("Telephone*")}</label>
                    <input
                      placeholder={t("Enter Telephone")}
                      type="text"
                      name="telephone"
                      value={values.telephone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                    {errors.telephone && touched.telephone && (
                      <p className="max-w-2xl text-sm leading-6 text-red-500">
                        {errors.telephone}
                      </p>
                    )}
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("Account Manager*")}</label>
                    <input
                      placeholder={t("Enter Account Manager")}
                      type="text"
                      name="accountManager"
                      value={values.accountManager}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                    {errors.accountManager && touched.accountManager && (
                      <p className="max-w-2xl text-sm leading-6 text-red-500">
                        {errors.accountManager}
                      </p>
                    )}
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">
                      {t("Account Manager Mobile*")}
                    </label>
                    <input
                      placeholder={t("Enter Account Manager Mobile")}
                      type="text"
                      name="accountManagerMobile"
                      value={values.accountManagerMobile}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                    {errors.accountManagerMobile &&
                      touched.accountManagerMobile && (
                        <p className="max-w-2xl text-sm leading-6 text-red-500">
                          {errors.accountManagerMobile}
                        </p>
                      )}
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("Provider No")}</label>
                    <input
                      placeholder={t("Enter Provider No")}
                      type="text"
                      name="providerNo"
                      value={values.providerNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>

                  <div className="flex gap-1 flex-col">
                    <label className="text-sm">{t("Payer CHI")}</label>
                    <input
                      placeholder={t("Enter Payer CHI")}
                      type="text"
                      name="payerChi"
                      value={values.payerChi}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>

              <div className="patient-details !mb-3">
                <div class="flex items-center  gap-2 !mb-2">
                  <div class="inventory-svg">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="34" height="34" rx="8" fill="#F4F6F8" />
                      <path
                        d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                        fill="#F5793B"
                      />
                      <path
                        d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                        fill="#F5793B"
                      />
                    </svg>
                  </div>
                  <div class="personal-head">
                    <span>{t("Address")}</span>
                  </div>
                </div>
                <div className="mt-6">
                  <div className="details-fields grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3">
                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Street*")}</label>
                      <input
                        placeholder={t("Enter Street")}
                        type="text"
                        name="street"
                        value={values.street}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                      {errors.street && touched.street && (
                        <p className="max-w-2xl text-sm leading-6 text-red-500">
                          {errors.street}
                        </p>
                      )}
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">
                        {t("Additional Street")}
                      </label>
                      <input
                        placeholder={t("Enter Additional Street")}
                        type="text"
                        name="additionalStreet"
                        value={values.additionalStreet}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Building Number")}</label>
                      <input
                        placeholder={t("Enter Building Number")}
                        type="text"
                        name="buildingNumber"
                        value={values.buildingNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("City*")}</label>
                      <input
                        placeholder={t("Enter City")}
                        type="text"
                        name="city"
                        value={values.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                      {errors.city && touched.city && (
                        <p className="max-w-2xl text-sm leading-6 text-red-500">
                          {errors.city}
                        </p>
                      )}
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Postal Code*")}</label>
                      <input
                        placeholder={t("Enter Postal Code")}
                        type="text"
                        name="postalCode"
                        value={values.postalCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                      {errors.postalCode && touched.postalCode && (
                        <p className="max-w-2xl text-sm leading-6 text-red-500">
                          {errors.postalCode}
                        </p>
                      )}
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Province/State")}</label>
                      <input
                        placeholder={t("Enter Province/State")}
                        type="text"
                        name="provinceState"
                        value={values.provinceState}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">
                        {t("District/Neighborhood")}
                      </label>
                      <input
                        placeholder={t("Enter District/Neighborhood")}
                        type="text"
                        name="districtNeighborhood"
                        value={values.districtNeighborhood}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="patient-details !mb-3">
                <div class="flex items-center  gap-2 !mb-2">
                  <div class="inventory-svg">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="34" height="34" rx="8" fill="#F4F6F8" />
                      <path
                        d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                        fill="#F5793B"
                      />
                      <path
                        d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                        fill="#F5793B"
                      />
                    </svg>
                  </div>
                  <div class="personal-head">
                    <span>{t("Financial Agreement and Discount")}</span>
                  </div>
                </div>
                <div className="mt-6">
                  <div className="details-fields grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("General %")}</label>
                      <input
                        placeholder={t("Enter General %")}
                        type="text"
                        name="generalPercent"
                        value={values.generalPercent}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Lab %")}</label>
                      <input
                        placeholder={t("Enter Lab %")}
                        type="text"
                        name="labPercent"
                        value={values.labPercent}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Radiology %")}</label>
                      <input
                        placeholder={t("Enter Radiology %")}
                        type="text"
                        name="radiologyPercent"
                        value={values.radiologyPercent}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Oral %")}</label>
                      <input
                        placeholder={t("Enter Oral %")}
                        type="text"
                        name="oralPercent"
                        value={values.oralPercent}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Meds %")}</label>
                      <input
                        placeholder={t("Enter Meds %")}
                        type="text"
                        name="medsPercent"
                        value={values.medsPercent}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Procedure %")}</label>
                      <input
                        placeholder={t("Enter Procedure %")}
                        type="text"
                        name="procedurePercent"
                        value={values.procedurePercent}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Package %")}</label>
                      <input
                        placeholder={t("Enter Package %")}
                        type="text"
                        name="packagePercent"
                        value={values.packagePercent}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Prompt Payment")}</label>
                      <input
                        placeholder={t("Enter Prompt Payment")}
                        type="text"
                        name="promptPayment"
                        value={values.promptPayment}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="patient-details !mb-3">
                <div class="flex items-center  gap-2 !mb-2">
                  <div class="inventory-svg">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="34" height="34" rx="8" fill="#F4F6F8" />
                      <path
                        d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                        fill="#F5793B"
                      />
                      <path
                        d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                        fill="#F5793B"
                      />
                    </svg>
                  </div>
                  <div class="personal-head">
                    <span>{t("Approvals Setup")}</span>
                  </div>
                </div>
                <div className="mt-6">
                  <div className="details-fields grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Approval Limit")}</label>
                      <input
                        placeholder={t("Enter Approval Limit")}
                        type="text"
                        name="approvalLimit"
                        value={values.approvalLimit}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Not covered ICD")}</label>
                      <input
                        placeholder={t("Enter Not covered ICD")}
                        type="text"
                        name="notCoveredIcd"
                        value={values.notCoveredIcd}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">{t("Approval ICD")}</label>
                      <input
                        placeholder={t("Enter Approval ICD")}
                        type="text"
                        name="approvalIcd"
                        value={values.approvalIcd}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>

                    <div className="flex gap-1 flex-col">
                      <label className="text-sm">
                        {t("Supply days approvals")}
                      </label>
                      <input
                        placeholder={t("Enter Supply days approvals")}
                        type="text"
                        name="supplyDaysApprovals"
                        value={values.supplyDaysApprovals}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-6 flex justify-end">
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    backgroundImage:
                      "linear-gradient(83deg, #f14f3e 25%, #0070C2 100%)",
                  }}
                  startIcon={<DoneAllIcon />}
                  size="small"
                >
                  {t("Create New Payer")}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default PayerManagementForm;
